import {Injectable, OnDestroy} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {filter, map, switchMap, takeUntil} from 'rxjs/operators';
import {USER_TOPIC} from '../../../../main';
import {DownloadFileDaoService} from './download-file-dao.service';
import {DownloadFileEvent} from '../../models';
import {R2CloudStompService} from '../../ws/r2-cloud-stomp.service';

@Injectable({
    providedIn: 'root'
})
export class DownloadFileService implements OnDestroy {
    private onDestroy$ = new Subject<void>();
    private readonly stompSubscription!: Subscription;

    constructor(private stomp: R2CloudStompService, private downloadFileDaoService: DownloadFileDaoService) {
        console.debug('download-file: start');

        this.stompSubscription = this.stomp.stompTopic<DownloadFileEvent>(`${USER_TOPIC}/download-file`)
            .pipe(
                takeUntil(this.onDestroy$),
                filter(e => !!e && e.id != null && e.id > 0),
                switchMap(event => this.downloadFileDaoService.downloadById(event.id ?? 0).pipe(
                    map(downloadFile => ({downloadFile, event}))
                )))
            .subscribe(({downloadFile, event}) => {
                if (downloadFile) {
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(downloadFile);
                    link.download = event.name ?? '';
                    link.click();
                }
            });
    }

    stompUnsubscribe(): void {
    }

    ngOnDestroy(): void {
        this.stompUnsubscribe();
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
